import { render, staticRenderFns } from "./photo-material.vue?vue&type=template&id=a5ea5810&scoped=true&"
import script from "./photo-material.vue?vue&type=script&lang=js&"
export * from "./photo-material.vue?vue&type=script&lang=js&"
import style0 from "./photo-material.vue?vue&type=style&index=0&id=a5ea5810&scoped=true&lang=scss&"
import style1 from "./photo-material.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ea5810",
  null
  
)

export default component.exports